import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';

const AppContainer = props => (
  <div>
    <Provider {...props}>{props.children}</Provider>
  </div>
);

AppContainer.propTypes = {
  store: PropTypes.object.isRequired,
  children: PropTypes.any,
};

export default AppContainer;
